import { Card, Grid } from 'core/components';
import React, { PropsWithChildren } from 'react';

function PlanCardContainer({ children, ...rest }: PropsWithChildren<object>): JSX.Element {
  return (
    <Card p={2} {...rest}>
      <Grid gridTemplateColumns="2fr 1fr" gridTemplateRows="1fr">
        {children}
      </Grid>
    </Card>
  );
}

export default PlanCardContainer;
